import React from 'react';
import dayjs from "dayjs";
import classnames from 'classnames';
import FieldInput from '../../../../common/components/FieldInput';
import FieldDatepicker from "../../../../common/components/FieldDatepicker";
import FieldSelect from "../../../../common/components/FieldSelect";
import {limitIntegerValueLength} from "../../../../common/utils/form/limitValueLength";
import {taskStatuses} from '../../../../common/constants/options';
import styles from './styles.module.scss';

const TaskVisit = ({formik}) => {

  return (
    <div className={styles.modalContentContainer}>
      <FieldDatepicker
        fieldId="taskDueDate"
        mandatoryMark={true}
        label={'תאריך לביצוע'}
        maxDate={dayjs().add(10, 'year')}
        containerStyles={classnames(styles.halfSize, styles.paddingBottom)}
      />
      <FieldSelect
        fieldId="taskStatusID"
        options={taskStatuses}
        mandatoryMark={true}
        label={'סטטוס'}
        containerStyles={classnames(styles.halfSize, styles.paddingBottom)}
      />
      <div className={classnames(styles.fullRow, styles.paddingBottom)}>
        <FieldInput
          fieldId="visitContactName"
          value={formik.values.visitContactName}
          label="פרטי המציג - שם מלא"
          containerCustomStyles={styles.halfSize}
        />
        <FieldInput
          fieldId="visitContactPhone"
          value={formik.values.visitContactPhone}
          label="פרטי המציג - מספר נייד"
          onChange={limitIntegerValueLength(10)}
          containerCustomStyles={styles.halfSize}
        />
      </div>
      <FieldInput
        fieldId="notes"
        value={formik.values.notes}
        label="הערות"
      />
    </div>
  )
};

export default TaskVisit;
